import { type QueryKey } from '@tanstack/react-query'
import { type TagId, type TagListInput } from '@terros/common'

export const tagKey = (tagId?: TagId): QueryKey => {
  if (!tagId) return ['tag']
  return ['tag', tagId]
}
export const tagsKey = (input?: TagListInput): QueryKey => {
  if (!input) return ['tags']
  return ['tags', input]
}
